import { render, staticRenderFns } from "./affixService.vue?vue&type=template&id=0f268223&scoped=true"
import script from "./affixService.vue?vue&type=script&lang=js"
export * from "./affixService.vue?vue&type=script&lang=js"
import style0 from "./affixService.vue?vue&type=style&index=0&id=0f268223&prod&lang=scss&scoped=true"
import style1 from "./affixService.vue?vue&type=style&index=1&id=0f268223&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f268223",
  null
  
)

export default component.exports